import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import environment from './environment';
import options from './options';
import hpsEnrollForm from './hpsEnrollForm';
import hpsReplaceForm from './hpsReplaceForm';
import patientEnrollForm from './patientEnrollForm';
import patientReplaceForm from './patientReplaceForm';
import pharmaEnrollForm from './pharmaEnrollForm';
import pharmaReplaceForm from './pharmaReplaceForm';

export default combineReducers({
  routing: routerReducer,
  form,
  environment,
  options,
  hpsEnrollForm,
  hpsReplaceForm,
  pharmaEnrollForm,
  pharmaReplaceForm,
  patientEnrollForm,
  patientReplaceForm,
});
